'use client';

import Image from 'next/image';
import clsx from 'clsx';
import { AnimatePresence, motion, type Variants } from 'framer-motion';
import { WordRotate } from 'ui';
import notesIcon from '../../../../public/images/notes-app-icon.png';

interface GradualSpacingProps {
  duration?: number;
  delayMultiple?: number;
  framerProps?: Variants;
  className?: string;
}

export function HeroTitle({
  duration = 0.5,
  delayMultiple = 0.05,
  framerProps = {
    hidden: { opacity: 0, x: -20 },
    visible: { opacity: 1, x: 0 },
  },
  className,
}: GradualSpacingProps) {
  const text = [
    'Turn ',
    <Image
      alt="Apple Notes"
      height={80}
      src={notesIcon}
      width={80}
      className="inline-block size-[1.3em]"
      priority
      key="notes icon"
    />,
    ' Apple ',
    'Notes ',
    'into ',
    <WordRotate
      className="w-[333px] bg-linear-to-br from-brand-700 to-brand-500 bg-clip-text text-transparent"
      key="word rotate"
      words={['blogs', 'newsletters', 'portfolios', 'portals']}
    />,
    ' in ',
    'minutes',
  ];
  return (
    <h1 className="mx-auto max-w-5xl text-balance pb-6 text-display-lg font-bold text-gray-900 sm:text-display-xl">
      <AnimatePresence>
        {text.map((char, i) => (
          <motion.span
            key={i}
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={framerProps}
            transition={{ duration, delay: i * delayMultiple }}
            className={clsx(
              'drop-shadow-xs',
              // Fix WordRotate layout shifting on Safari
              i === 5 && 'inline-block w-[333px]',
              className,
            )}
          >
            {char === ' ' ? <span>&nbsp;</span> : char}
          </motion.span>
        ))}
      </AnimatePresence>
    </h1>
  );
}
